const VerticalSpacer = () => {
  return <div className="h-20" />;
};

export default VerticalSpacer;
